import React, { FC } from 'react'
import { Divider, DividerProps } from '@mui/material'

export const EvtDivider: FC<DividerProps> = ({ children, ...props }) => {
    return <Divider {...props}>{children}</Divider>
}

export default EvtDivider
